import React from "react";
import { heroBanners } from "../mock";
import { ArrowRight } from "lucide-react";

const byId = (id) => heroBanners.find((b) => b.id === id);

function Tile({ banner, className = "", big = false }) {
  if (!banner) return null;
  return (
    <a
      href="#categories"
      className={`group relative overflow-hidden rounded-2xl ${className}`}
    >
      <img
        src={banner.image}
        alt={banner.title}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/85 via-navy-dark/25 to-transparent" />
      <div className={`relative flex h-full flex-col justify-end ${big ? "p-6 md:p-8" : "p-5"}`}>
        <h3 className={`font-heading font-extrabold text-white ${big ? "text-2xl md:text-4xl max-w-md" : "text-lg md:text-xl"}`}>
          {banner.title}
        </h3>
        <p className={`mt-1 text-white/80 ${big ? "text-sm md:text-base max-w-sm" : "text-xs"}`}>
          {banner.subtitle}
        </p>
        <span className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-brand px-4 py-2 text-xs font-bold uppercase tracking-wide text-white transition-all group-hover:gap-2.5 group-hover:bg-brand-dark">
          {banner.cta} <ArrowRight size={14} />
        </span>
      </div>
    </a>
  );
}

export default function Hero() {
  return (
    <section className="mx-auto max-w-7xl px-4 pt-6 lg:px-8">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:grid-rows-2 md:h-[560px]">
        <Tile banner={byId("smith")} className="col-span-2 h-56 md:col-span-1 md:row-span-2 md:h-full" />
        <Tile banner={byId("nuobell")} big className="col-span-2 h-64 md:col-span-2 md:row-span-2 md:h-full" />
        <Tile banner={byId("pilates")} className="h-40 md:col-span-1 md:h-full" />
        <Tile banner={byId("garage")} className="h-40 md:col-span-1 md:h-full" />
      </div>
    </section>
  );
}
